// import * as accountApi from '@motionelements/core/src/api/account.js';
import * as elementsApi from '@/api/artist/elements';

const state = {
  mt: null,
  activeStep: 1,
  uploadType: 'single',
  artistMediaTypes: [],
  anyPending: false,
  //
  isLoaded: false,
  //
  uploadMediaTypeGroups: [
    {
      id: 'stock',
      mediaTypes: ['animation', 'video_live', 'music', 'sfx', 'photo', '3d_model', 'lottie', 'vector'],
    },
    {
      id: 'template',
      mediaTypes: ['ae', 'resolve', 'pr', 'fcp', 'graphic_template', 'ui_template', 'presentation_template'],
    },
    {
      id: 'url',
      mediaTypes: ['notion_template'],
    },
    {
      id: 'prompt',
      mediaTypes: ['midjourney_prompt'],
    },
  ],
};

const getters = {
  groupMediaTypes(state) {
    return (groupId) => {
      const targetGroup = state.uploadMediaTypeGroups.find(({ id }) => id === groupId);
      return _.get(targetGroup, 'mediaTypes', []);
    };
  },
};

const mutations = {
  setMediaType(state, mt) {
    state.mt = mt;
  },
  setUploadType(state, uploadType) {
    state.uploadType = uploadType;
  },
  setActiveStep(state, step) {
    state.activeStep = step;
  },
  setArtistMediaTypes(state, artistMediaTypes) {
    state.artistMediaTypes = artistMediaTypes;
  },
  setAnyPending(state, status) {
    state.anyPending = status;
  },
  //
  setIsLoaded(state, boolean) {
    state.isLoaded = boolean;
  },
};

const actions = {
  createElement(store, { file, mediaType }) {
    return elementsApi.createElement({
      url: file.uploadURL.replace('%2Fstock%2F', '/stock/'), // path separators are escaped
      mediaType,
      originalPath: file.meta.relativePath || file.meta.name, // uppy will return relatvePath if folder is dropped ELSE it will be null
    });
  },
  GET_ARTIST_ELEMENTS_STATS({ commit }) {
    elementsApi.getElementsStats()
      .then(({ data: { data: stats } }) => {
        let types = stats.map(x => x.mediaType).filter(x => x !== 'all');
        types = types.length ? types : ['video', 'photo', 'music'];
        commit('setArtistMediaTypes', types.slice(0, 5));
        commit('setIsLoaded', true);
      });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
